import React from 'react';
import { Link } from 'react-router-dom';
import CustomBootstrapIcon from '../CustomBootstrapIcon/CustomBootstrapIcon';
import s from './Breadcrumb.module.scss';

const Breadcrumb = ({
    items = [],
    className = ""
}) => {


    return (
        <div className={s.breadcrumb}>
            <nav className={`d-flex align-items-center text-sm ${className}`} aria-label="Breadcrumb">
                <ol className="d-flex align-items-center m-0 p-0 list-unstyled">
                    {items.map((item, index) => {
                        const isLast = index === items.length - 1;

                        return (
                            <li key={index} className="d-flex align-items-center me-2 text-nowrap">
                                {index > 0 && (
                                    <span className="text-gray-400 me-2" aria-hidden="true">
                                        <CustomBootstrapIcon icon="ChevronRight" size={16} />
                                    </span>
                                )}

                                {isLast ? (
                                    <span className={`${s.selectedItem} text-dark fw-medium d-inline-flex align-items-center`} aria-current="page">
                                        {item.icon && <span className="me-1">{item.icon}</span>}
                                        {item.label}
                                    </span>
                                ) : (
                                    <Link
                                        to={item.href || '#'}
                                        className={`${s.linkItem} d-inline-flex align-items-center`}
                                    >
                                        {item.icon && <span className="me-1">{item.icon}</span>}
                                        {item.label}
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumb;


/*Example usage:

const breadcrumbItems = [
    { label: 'Products', href: '/products' },
    { label: 'Electronics', href: '/products/electronics' },
    { label: 'Smartphones', href: '/products/electronics/smartphones' },
    { label: 'iPhone 15 Pro' } // Last item has no href (current page)
  ];

<Breadcrumb items={itemsWithHandlers}/>

*/